import React from "react";
export const CountryTypeFormatter = (cellContent, row, rowIndex) => {
  const { country } = row;
  const { name = "-" } = country || {};
  return (
    <>
      <div className="d-flex align-items-center text-capitalize">{name}</div>
    </>
  );
};
